import { Outlet } from 'react-router-dom';
import { Navbar } from '../components/Navbar/Navbar';
import { Footer } from '../components/Footer/Footer';

export const Layout = () => (
  <div className="storyline-scope bg-paper text-ink font-sans antialiased min-h-screen flex flex-col">
    <Navbar />
    <div className="hazard-stripe" />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
  </div>
);
